import { getHeaderNavInfo, getHeaderDataFromCms } from 'js/api/header'
import Handlebars from 'js/libs/handlebars.js'

var activePathname = window.location.pathname
let headerJson = null

getHeaderNavInfo().then((result) => {
  if (result.code === 0 || result.code === '0') {
    headerJson = JSON.parse(result.data.navHeader)
    renderSidebar(headerJson)
  } else {
    renderSidebar(headerJson)
  }
})

let firstMenuIndex = -1
let subMenuIndex = -1
let _activeMenu = null
let hideMenuTimeout = null
let showMenuTimeout = null
let headerNavJson = null

Handlebars.registerHelper('isSthzOrFwzc', function (v1 = 'other', options) {
  if (['sthz', 'fwzc'].includes(v1)) {
    return true
  } else {
    return false
  }
})

Handlebars.registerHelper('notSthzOrFwzc', function (v1 = 'other', options) {
  if (['sthz', 'fwzc'].includes(v1)) {
    return false
  } else {
    return true
  }
})

Handlebars.registerHelper('isFwzc', function (v1 = 'other', options) {
  if (['fwzc'].includes(v1)) {
    return true
  } else {
    return false
  }
})

Handlebars.registerHelper('overChildren', function (v1) {
  if (v1.length > 11) {
    return true
  } else {
    return false
  }
})

Handlebars.registerHelper('sliceChildren', function (v1, v2) {
  if (v2) {
    return v1.slice(0, Math.ceil(v1.length / 2))
  } else {
    return v1.slice(Math.ceil(v1.length / 2))
  }
})

Handlebars.registerHelper('editClass', function (v1, v2) {
  if (v1 === 'sthz') {
    return v2 + ' sub-menu_mct__sthz'
  } else {
    return v2
  }
})

Handlebars.registerHelper('editClassDesc', function (v1, v2) {
  if (v1) {
    return v2
  } else {
    return v2 + ' mct__children_item_nodesc'
  }
})

Handlebars.registerHelper('activeClass', function (v1, v2) {
  if (v1 === 0) {
    return v2 + ' st-item__active'
  } else {
    return v2
  }
})

const showMenuPanel = (index) => {
  if (hideMenuTimeout) {
    clearTimeout(hideMenuTimeout)
    hideMenuTimeout = null
  }
  if (showMenuTimeout) {
    clearTimeout(showMenuTimeout)
    showMenuTimeout = null
  }
  if (index === -1) {
    _activeMenu = null
    subMenuIndex = -1
    return
  }
  if (index !== firstMenuIndex) {
    subMenuIndex = 0
  } else {
    return
  }

  const _len = (headerNavJson[index] && headerNavJson[index].children && headerNavJson[index].children.length) || 0
  firstMenuIndex = _len > 0 ? index : -1
  $(`.menu-item`).eq(index).siblings('.menu-item').removeClass('menu-item__active')
  if (firstMenuIndex > -1) {
    let _height = 0
    $(`.menu-item`).eq(firstMenuIndex).addClass('menu-item__active')
    _activeMenu = headerNavJson[firstMenuIndex]
    if (_activeMenu.type === 'fwzc') {
      _height = 320
    } else if (_activeMenu.type === 'sthz') {
      _height = 540
    } else {
      const _len = (_activeMenu.children && _activeMenu.children.length) || 0
      _height = _len * 34 + (_len - 1) * 20 + 220 + 31
      if (_len > 11) {
        _height = Math.floor(_len / 2) * 34 + (Math.floor(_len / 2) - 1) * 20 + 220 + 31
      }
      if (_height !== 0) {
        _height = Math.max(_height, 540)
      }
    }
    $('.menu-panel').css({
      height: `${_height}px`
    })
    let _children = []
    let _title = ''
    if (['fwzc', 'sthz'].includes(_activeMenu.type)) {
      $('.sm__left').addClass('sm__left-noscheme')
      $('.sm__middle').addClass('sm__middle__noscheme')
      $('.sm__right').addClass('sm__right__none')
      _children = _activeMenu.children
    } else {
      $('.sm__left').removeClass('sm__left-noscheme')
      $('.sm__middle').removeClass('sm__middle__noscheme')
      $('.sm__right').removeClass('sm__right__none')
      _children = _activeMenu.children[0].children
      _title = _activeMenu.children[0].title
    }
    if (_activeMenu.children && _activeMenu.children.length > 11) {
      $('.sm__left').addClass('sm__left-wrap')
      $('.sm__middle').addClass('sm__middle__noboxshadow')
      $('.sm__right').addClass('sm__right__none_wrap')
      const cardTpl = Handlebars.compile($('#card_wrap').html())
      $('.card-wrap').html(cardTpl(_activeMenu.boothList))
    } else {
      $('.sm__left').removeClass('sm__left-wrap')
      $('.sm__middle').removeClass('sm__middle__noboxshadow')
      $('.sm__right').removeClass('sm__right__none_wrap')
      if (_height !== 0 && !['fwzc', 'sthz'].includes(_activeMenu.type)) {
        let _len = _activeMenu.children[subMenuIndex].scheme.length
        const _h = _len * 36 + 44.4 - 10
        const schemeHeight = Math.min(_h, 0.54 * _height)
        const communityHeight = _height - schemeHeight - 31
        $('.scheme').css('height', `${schemeHeight}px`)
        $('.community').css('height', `${communityHeight}px`)
      }
      const schemeTpl = Handlebars.compile($('#scheme_ul').html())
      $('.scheme-ul').html(schemeTpl(_activeMenu.children[subMenuIndex].scheme))
      const communityTpl = Handlebars.compile($('#cy-ul__content').html())
      $('.cy-ul__content').html(communityTpl(_activeMenu.children[subMenuIndex].community))
      $('.scheme-ul').animate({ scrollTop: 0 })
      $('.cy-ul__content').animate({ scrollTop: 0 })
    }
    const leftMenuTpl = Handlebars.compile($('#left_menu').html())
    $('.sm__left-menu').html(leftMenuTpl(_activeMenu))
    if (subMenuIndex === 0) {
      const midMenuTpl = Handlebars.compile($('#sm__middle').html())
      $('.sm__middle_scroll').html(
        midMenuTpl({
          type: _activeMenu.type,
          title: _title,
          children: _children
        })
      )
    }
    $('.st-item').eq(subMenuIndex).addClass('st-item__active')
  } else {
    $('.menu-panel').css({
      height: `0px`
    })
  }
}

const hideMenuPanel = () => {
  hideMenuTimeout = setTimeout(() => {
    firstMenuIndex = -1
    subMenuIndex = -1
    $(`.menu-item`).siblings('.menu-item').removeClass('menu-item__active')
    $('.menu-panel').css({
      height: `0px`
    })
  }, 500)
}

const handleSubMenuMouseEnter = (index) => {
  if (_activeMenu.children && _activeMenu.children[index]) {
    subMenuIndex = index
    let _children = _activeMenu.children[index].children
    let _title = _activeMenu.children[index].title
    const midMenuTpl = Handlebars.compile($('#sm__middle').html())
    $('.sm__middle_scroll').html(
      midMenuTpl({
        type: _activeMenu.type,
        title: _title,
        children: _children
      })
    )
    const schemeTpl = Handlebars.compile($('#scheme_ul').html())
    $('.scheme-ul').html(schemeTpl(_activeMenu.children[subMenuIndex].scheme))
    const communityTpl = Handlebars.compile($('#cy-ul__content').html())
    $('.cy-ul__content').html(communityTpl(_activeMenu.children[subMenuIndex].community))
  }
}

function isActive (item) {
  if (!item) return false
  var startIndex = item.indexOf('/services') || item.indexOf('/service')
  var endIndex = item.indexOf('?') > -1 ? item.indexOf('?') : item.length
  return item.slice(startIndex, endIndex).replace('services', 'service') === activePathname
}

function siderBindEvent () {
  $('.sidebar-group-heading').on('click', function () {
    var isActive = $(this).parents('.sidebar-group').hasClass('active')
    $('.sidebar-group').removeClass('active')
    if (!isActive) {
      $(this).parents('.sidebar-group').addClass('active')
    }
  })
}

const renderSidebar = () => {
  var sidebarHtml = `
  <div class="sidebar-top">产品&amp;服务</div>
  <div class="sidebar-links">`
  headerJson &&
    headerJson[0].items &&
    headerJson[0].items.forEach((item) => {
      item.items.map((navItem) => {
        var headingActive = false
        navItem.items.forEach((i) => {
          if (isActive(i.path)) {
            headingActive = true
          }
        })
        sidebarHtml += `
      <div class="sidebar-group ${headingActive ? 'active' : ''}">
        <div class="sidebar-group-heading">
          <span>${navItem.title}</span>
          <i class="line-arrow down"></i>
        </div>
        <div class="dropdown-transition">
          <div class="sidebar-group-items">`
        navItem.items.forEach((i) => {
          sidebarHtml += `<a href='${i.path}' class="sidebar-link ${isActive(i.path) ? 'active' : ''}">${i.title}</a>`
        })
        sidebarHtml += `
          </div>
        </div>
      </div>`
      })
    })
  sidebarHtml += `
  </div>`
  $('.main-content-wrapper .section-sidebar').append(sidebarHtml)
  siderBindEvent()
}

const bindEvent = () => {
  $('.menu-item').on('mouseenter', function () {
    const index = $(this).index() - 1
    showMenuPanel(index)
  })
  $('.menu-item').on('mouseleave', function () {
    hideMenuPanel()
  })
  $('.menu-panel').on('mouseenter', function () {
    showMenuPanel(firstMenuIndex)
  })
  $('.menu-panel').on('mouseleave', function () {
    hideMenuPanel()
  })
  $('body').delegate('.sub-menu .icon-close', 'click', function () {
    firstMenuIndex = -1
    $('.menu-panel').css({
      height: '0px'
    })
  })
  $('body').delegate('.sub-menu .st-item__right', 'mouseleave', function () {
    clearTimeout(showMenuTimeout)
    showMenuTimeout = null
  })
  $('body').delegate('.st-item', 'mouseenter', function () {
    const index = $(this).index()
    if (showMenuTimeout) {
      clearTimeout(showMenuTimeout)
      showMenuTimeout = null
    }
    showMenuTimeout = setTimeout(() => {
      $('.st-item').removeClass('st-item__active')
      $(this).addClass('st-item__active')
      if (!_activeMenu) return
      if ($(this).hasClass('st-item__right')) {
        const _len = (_activeMenu.children && _activeMenu.children.length) || 0
        handleSubMenuMouseEnter(_len / 2 + index)
      } else {
        handleSubMenuMouseEnter(index)
      }
      clearTimeout(showMenuTimeout)
    }, 300)
  })
}

getHeaderDataFromCms().then((result) => {
  if (result.code === 0 || result.code === '0') {
    const _data = JSON.parse(result.data.navCommon).body.items[0].jsonData.menuList
    headerNavJson = _data
    const menuLiTpl = Handlebars.compile($('#menu_li').html())
    $('.menu-container').html(menuLiTpl(_data))
    bindEvent()
  }
})



// WEBPACK FOOTER //
// ./src/js/libs/utils-header-sidebar.js